import RiotEventManager   from 'utilities/riot/event_manager';
import { AddressSearchUtil } from 'utilities/address';
import serializeJSON from 'utilities/serialize_json';
import { parse, stringify } from 'query-string';
import visit from 'utilities/visit';
import {
  DELIVERY_SELECT_START_DATE,
  DELIVERY_CLICK_DOWNLOAD,
  DELIVERY_CLICK_LETTER,
  DELIVERY_CLICK_LABELS,
  DELIVERY_CLICK_SAVE,
  DELIVERY_CLICK_EACH_SAVE,
  TAG_UPDATED, AJAX_ACCECCED, AJAX_ACCECCING
} from 'apps/events';
import { save }         from "apps/actions/common";
export default class TodaysDeliveriesController {
  eventManager: RiotEventManager;
  tag;
  tagScope: string;
  constructor(tag){
    this.tag = tag;
    this.tagScope = tag.tagScope;
    this.eventManager = new RiotEventManager(tag)
    this.customEvent(DELIVERY_SELECT_START_DATE, (e) => { this.onSelectStartDate(e) });
    this.customEvent(DELIVERY_CLICK_DOWNLOAD, (e) => { this.onClickDownload(e) });
    this.customEvent(DELIVERY_CLICK_LETTER, (e) => { this.onClickLetter(e) });
    this.customEvent(DELIVERY_CLICK_LABELS, (e) => { this.onClickLabels(e) });
    this.customEvent(DELIVERY_CLICK_SAVE, (e) => { this.onClickSave(e) });
    this.customEvent(DELIVERY_CLICK_EACH_SAVE, (e) => { this.onClickEachSave(e) });
  }
  customEvent(event_name: string, callback: (e) => void){
    this.eventManager.customEvent(event_name, callback);
  }
  reduxEvent(scope: string, callback:(newVal, oldVal, objectPath) => void){
    this.eventManager.reduxEvent(scope, callback);
  }
  updateData(newVal){
    App.store.dispatch(App.actions.data.update(newVal));
  }
  onSelectStartDate(e){
    let date = e.detail;
    let params = { d: date.format('YYYY-MM-DD') };
    App.location.visit({ search: params });
  }
  onClickDownload(ev){
    let fe = document.getElementById('delivery-task')
    let json = serializeJSON(fe);
    if(!json['taskable_ids']){ return; }
    let path = '/csv/delivery.csv?tasks_delivery_ids=' + json['taskable_ids']
    path += '&d=' + json['d']
    path += '&vendor=yamato'
    App.location.blank(path)
    // this.send(ev, 'csv')
  }
  onClickLetter(ev){
    let fe = document.getElementById('delivery-task')
    let json = serializeJSON(fe);
    if(!json['taskable_ids']){ return; }
    let path = '/excel/letters.xslx?tasks_delivery_ids=' + json['taskable_ids']
    path += '&d=' + json['d']
    App.location.blank(path)
    // this.send(ev, 'letter')
  }
  onClickLabels(ev){
    let fe = document.getElementById('delivery-task')
    let json = serializeJSON(fe);
    if(!json['taskable_ids']){ return; }
    let path = '/pdf/labels.pdf?tasks_delivery_ids=' + json['taskable_ids']
    path += '&d=' + json['d']
    App.location.blank(path)
    // this.send(ev, 'letter')
  }
  onClickSave(ev){
    this.send(ev, '')
  }
  onClickEachSave(ev){
    this.send(ev, '', [ev.detail])
  }
  private send(ev, then, taskable_ids = null){
    let payload = {
      at: App.authenticity_token(),
    };
    let fe = document.getElementById('delivery-task')
    payload['params'] = serializeJSON(fe);
    payload['params']['then'] = then
    if(taskable_ids){payload['params']['taskable_ids'] = taskable_ids}
    if(!payload['params']['taskable_ids']){ return; }
    payload['params']['detail'] = ev.detail;
    payload['url'] = fe.getAttribute('action');
    payload['method'] = 'POST';
    payload['scope'] = this.tagScope;
    let e = new CustomEvent(AJAX_ACCECCING, {detail: this.tagScope});
    document.dispatchEvent(e);
    App.store.dispatch(save(payload));
  }
  protected onSaved(newVal: any, oldVal: any, objectPath: string){
    let e = new CustomEvent(AJAX_ACCECCED, {detail: this.tagScope});
    document.dispatchEvent(e);
  }
  // onClickDownload(e){
  //   let vendor = e.detail;
  //   let fe = document.getElementById('delivery-download')
  //   let json = serializeJSON(fe);
  //   let r = this.getStringify(json);
  //   let params = {v: vendor, r: r, d: json.d };
  //   let query = AddressSearchUtil.stringify(params)
  //   let url   = '/csv/delivery.csv?' + query;
  //   App.location.blank(url)
  // }
  // getStringify(json){
  //   let taskable_ids = json.taskable_ids
  //   if(taskable_ids == null){ return {}; }
  //   if(taskable_ids.length <= 0){ return {}; }
  //   let params = {};
  //   for(let i=0; i<taskable_ids.length; i++){
  //     let taskable_id = json.taskable_ids[i]
  //     let number = json.numbers[taskable_id]
  //     params[taskable_id.toString()] = number;
  //   }
  //   // let inputs = document.querySelectorAll('input[class="taskable_ids_checkbox"][value="1"]')
  //   // for(let i=0; i< inputs.length; i++){
  //   //   let input = inputs[i] as HTMLInputElement;
  //   //   console.log(input.value);
  //   // }
  //   return JSON.stringify(params);
  // }
}
